// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2M9q2","errors":"Errors_errors__3cNtO"};